module.exports = __webpack_public_path__ + "static/img/4bac.ca7a7fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/4bac.jpg
// module id = 4rjW
// module chunks = 1